// LUMINA · pages/vajra/constants.js
// Phase 39D: extracted from VajraPortal.jsx — palette, business constants, label maps

// Phase 121B: subscriber label display map (mirrors backend vajra.py LABEL_DISPLAY_MAP)
export const SUBSCRIBER_LABELS = {
  "GENERAL":             "通用法讯",
  "拉则祖古":              "拉则祖古",
  "堪仁波切格西嘉滇":        "堪仁波切 · 格西嘉滇",
  "益西祖古":              "益西祖古",
  "法界宝藏论":             "法界宝藏论",
  "那若六法":              "那若六法",
  "普巴金刚":              "普巴金刚",
  "如意珠度母":             "如意珠度母",
  "夏扎巴大圆满":            "夏扎巴大圆满",
  "SakyaEvents":         "萨迦法会",
  "BTF TEAM":            "BTF 团队",
  "宁玛":                  "宁玛",
  "萨迦":                  "萨迦",
  "噶举":                  "噶举",
  "格鲁":                  "格鲁",
  "觉囊":                  "觉囊",
};

export const API   = "/api";
export const CR    = "#6B1A1A";   // crimson (legacy ref only)
export const CRL   = "#8B2A2A";   // crimson light (legacy)
export const DG    = "#064E3B";   // dark green (events / nature)
export const GD    = "#6B4F10";   // dark gold — primary accent on light bg
export const GDL   = "#8B6914";   // gold mid
export const GDB   = "#C9A84C";   // gold bright (borders / decorative)
export const GDH   = "#D4AF37";   // 琉璃金 — highlight (active states, featured pills)
export const BG    = "#FDFBF7";   // parchment
export const PANEL = "rgba(255,255,255,0.96)";
export const TXT   = "#2D1810";   // warm dark text
export const TXT2  = "#6B4C3B";   // warm muted text

// Phase 33: timezone utils (fixed DST offsets, no external deps)
export const TZ_OFFSETS = {
  "America/Vancouver":-7,"America/Toronto":-4,"America/New_York":-4,
  "America/Chicago":-5,"America/Denver":-6,
  "Europe/London":+1,"Europe/Paris":+2,
  "Asia/Kolkata":+5.5,"Asia/Shanghai":+8,"Asia/Tokyo":+9,"Australia/Sydney":+10,
};
export const TZ_LABELS = {
  "America/Vancouver":"PT","America/Toronto":"ET","America/New_York":"ET",
  "Europe/London":"BST","Asia/Shanghai":"北京","Asia/Tokyo":"东京","Asia/Kolkata":"印度",
};

// 5-element dharma practice recommendations
export const ELEMENT_PRACTICES = {
  "金/White Tara": { element:"金", color:"#C0C0C0", bg:"rgba(192,192,192,0.08)", practices:["白度母心咒","金刚萨埵百字明","金刚手菩萨咒"] },
  "木/Tara":       { element:"木", color:"#228B22", bg:"rgba(34,139,34,0.08)",    practices:["绿度母心咒","文殊菩萨心咒","千手观音咒"] },
  "水/Guru Rinpoche":{ element:"水", color:"#1E90FF", bg:"rgba(30,144,255,0.08)", practices:["莲师心咒","普贤如来心咒","阿弥陀佛心咒"] },
  "火/Hayagriva":  { element:"火", color:"#CC2200", bg:"rgba(204,34,0,0.08)",    practices:["马头明王心咒","不动明王咒","金刚亥母心咒"] },
  "土/Yellow Jambhala":{ element:"土", color:"#B8860B", bg:"rgba(184,134,11,0.08)", practices:["黄财神心咒","地藏菩萨心咒","宝生如来心咒"] },
};

// Phase 114: Teaching type labels & colors (consolidated from individual components)
export const TYPE_LABEL = {
  teaching: '教法',
  empowerment: '灌顶',
  retreat: '闭关',
  practice: '修法',
  text_study: '经典研习',
};
export const TYPE_LABEL_EN = {
  teaching: 'Teaching',
  empowerment: 'Empowerment',
  retreat: 'Retreat',
  practice: 'Practice',
  text_study: 'Text Study',
};
export const TYPE_COLOR = {
  teaching: '#3b82f6',
  empowerment: '#dc2626',
  retreat: '#8b5cf6',
  practice: '#10b981',
  text_study: '#d97706',
};

// Event type labels & colors
export const EVENT_TYPE_LABEL = {
  puja:"法会", ritual:"法事", empowerment:"灌顶",
  teaching:"教法", retreat:"闭关", weekly_practice:"共修",
  other:"活动",
};
export const EVENT_TYPE_COLOR = {
  puja:"#6B1A1A", ritual:"#3730a3", empowerment:"#064E3B",
  teaching:"#B8860B", retreat:"#374151", weekly_practice:"#1e3a5f",
  other:"#555",
};

// File icons (treasury / resource library)
export const FILE_ICON = {pdf:"📄", video:"🎬", audio:"🎧", link:"🔗"};

// Resource category styles (preview)
export const CATEGORY_STYLE = {
  "前行":      { color:"#B8860B", dot:"rgba(184,134,11,0.8)" },
  "生起次第":  { color:GD,        dot:"rgba(107,26,26,0.8)"  },
  "圆满次第":  { color:"#5b21b6", dot:"rgba(91,33,182,0.8)"  },
};

// Phase 23: 修行资质 (credentials)
export const CRED_KEYS = [
  {key:"vajrakilaya",      label:"普巴金刚灌顶",    type:"empowerment"},
  {key:"tara",             label:"度母灌顶",         type:"empowerment"},
  {key:"simhamukha",       label:"作明佛母灌顶",     type:"empowerment"},
  {key:"medicine_buddha",  label:"药师佛灌顶",       type:"empowerment"},
  {key:"chenrezig",        label:"观世音菩萨灌顶",   type:"empowerment"},
  {key:"vajrasattva",      label:"金刚萨埵灌顶",     type:"empowerment"},
  {key:"manjushri",        label:"文殊菩萨灌顶",     type:"empowerment"},
  {key:"amitabha",         label:"阿弥陀佛灌顶",     type:"empowerment"},
  {key:"dzogchen_ngondro", label:"大圆满前行",        type:"practice"},
  {key:"naropa_6yogas",    label:"那若六法",          type:"practice"},
  {key:"mahamudra_ngondro",label:"大手印前行",        type:"practice"},
  {key:"tara_practice",    label:"度母修法",          type:"practice"},
  {key:"vajrakilaya_practice",label:"普巴金刚修法",   type:"practice"},
  {key:"tsalung",          label:"扎龙脉气修法",      type:"practice"},
];

export const CRED_TYPE_LABELS = {
  empowerment: "灌顶",
  in_progress: "修习中",
  completed:   "已圆满",
};

export const CRED_TYPE_COLORS = {
  empowerment: "#7c3aed",
  in_progress: "#d97706",
  completed:   "#065f46",
};

// Phase 39A → Phase 1 upgrade: Admin module groups reorganized into 4 functional hubs
// label = zh, labelEn = en
export const ADMIN_MODULES = [
  {
    key: "dharma_content_module", label: "📿 法义内容", labelEn: "📿 Dharma & Content",
    sections: [
      { key: "event",             label: "法会管理",   labelEn: "Events" },
      { key: "teachings",         label: "法教管理",   labelEn: "Teachings" },
      { key: "teachers",          label: "上师管理",   labelEn: "Teachers" },
      { key: "shop",              label: "法宝管理",   labelEn: "Dharma Shop" },
    ],
  },
  {
    key: "community_module", label: "👥 社群管理", labelEn: "👥 Community",
    sections: [
      { key: "overview",          label: "概览",       labelEn: "Overview" },
      { key: "practitioners",     label: "修行者",     labelEn: "Practitioners" },
      { key: "service_requests",  label: "服务祈请",   labelEn: "Service Requests" },
      { key: "subscribers", label: "📋 订阅者", labelEn: "Subscribers" },
      { key: "credentials",       label: "资质管理",   labelEn: "Credentials" },
      { key: "registrations",     label: "报名管理",   labelEn: "Registrations" },
      { key: "path_manager",      label: "修行次第",   labelEn: "Path" },
    ],
  },
  {
    key: "finance_ops_module", label: "💰 财务", labelEn: "💰 Finance",
    sections: [
      { key: "finance",          label: "财务收支",   labelEn: "Finance" },
      { key: "offering_mgmt",    label: "供养管理",   labelEn: "Offerings" },
      { key: "payment_config",   label: "支付配置",   labelEn: "Payment" },
    ],
  },
  {
    key: "system_comms_module", label: "📡 通讯与系统", labelEn: "📡 System",
    sections: [
      { key: "email_blast",   label: "邮件管理",   labelEn: "Email" },
      { key: "temples",       label: "寺院管理",   labelEn: "Temples" },
      { key: "hub_section",   label: "专题管理",   labelEn: "Topics" },
      { key: "tags",          label: "成员标签",   labelEn: "Tags" },
    ],
  },
];

// Phase 39C: 四账户财务系统 (4-account finance system)
export const ACC_LABELS = { event_fund:"法会专款", btf_general:"BTF基金", monastery_fund:"寺庙专项", teacher_fund:"上师专项" };
export const ACC_ICONS  = { event_fund:"⚡", btf_general:"🏛", monastery_fund:"🛕", teacher_fund:"🪷" };
export const ACC_COLORS = {
  event_fund:     { color:DG,        bg:"rgba(6,78,59,0.08)" },
  btf_general:    { color:GD,        bg:"rgba(139,105,20,0.08)" },
  monastery_fund: { color:"#7c3aed", bg:"rgba(124,58,237,0.08)" },
  teacher_fund:   { color:CR,        bg:"rgba(107,26,26,0.08)" },
};
export const INCOME_CATS  = ["法会报名费","随喜供养","上师专项供养","寺庙专项捐款","BTF一般捐款","功德主牌位","微信转账","现金收款","其他收入"];
export const EXPENSE_CATS = ["场地租金","上师机票","上师食宿","法会供品","打印材料","网站建设","寺庙汇款","上师转交","临时场地","日常法务","其他支出"];

// Phase 77: Vajra Portal i18n translation table
export const VAJRA_T = {
  en: {
    // ── Header ──────────────────────────────────────────
    brandName: "BTF Canada Vajra Community",
    brandSub: "BTF CANADA",
    staff: "Staff",
    signOut: "Sign Out",
    loading: "Loading…",
    loginRequired: "Login Required",

    // ── Tabs ────────────────────────────────────────────
    tabHome: "Home",
    tabPractice: "Practice",
    tabEvents: "Events",
    tabTeachers: "Lineage Teachers",
    tabTeachersSub: "",
    tabService: "Service",
    tabTeachings: "Teachings",
    tabTeachingsSub: "",
    tabSettings: "Settings",
    tabAdmin: "Admin",

    // ── VajraLanding ────────────────────────────────────
    landingHero: "Path to Awakening",
    landingHeroSub: "BTF CANADA Vajra Community",
    landingRecentEvents: "Upcoming Events",
    landingPastEvents: "Past Events",
    landingViewDetails: "View Details",
    landingOfferings: "Offerings",
    landingOfferingsBtn: "BTF CANADA Offerings →",
    landingFiveMerits: "Five Meritorious Activities",
    landingFiveMeritsSub: "Daily practice, monthly gatherings, annual retreats — the path unfolds naturally",
    landingTeachers: "Lineage Teachers",
    landingCommunity: "Community",
    landingFooter: "BTF Canada Vajra Community · BTF CANADA · Since 2024",
    landingNoEvents: "No upcoming events at this time",
    landingPastEventsEmpty: "Past events will appear here",
    landingLoginToView: "Login to view full content",

    // ── ServiceHub ──────────────────────────────────────
    serviceOfferings: "Merit Offerings",
    serviceRequests: "Dharma Requests",
    serviceShop: "Dharma Shop",
    serviceContact: "Contact Us",
    serviceOfferingsDesc: "Support the Three Jewels — accumulate merit through generosity",
    serviceRequestsDesc: "Request pujas, practices, and dharma services",
    serviceShopDesc: "Dharma items for free distribution",
    serviceContactDesc: "Get in touch with the BTF community",

    // ── DharmaHub ───────────────────────────────────────
    dharmaUpcoming: "Upcoming Events",
    dharmaPast: "Past Events",
    dharmaListView: "List View",
    dharmaCalendarView: "Calendar View",
    dharmaRecurring: "Recurring Practices",
    dharmaNoUpcoming: "No upcoming events — check back soon",
    dharmaNoPast: "Past events will appear here after completion",

    // ── PracticeHub ─────────────────────────────────────
    practicePath: "Dharma Path",
    practicePathDesc: "Step-by-step practice guide across five lineages",
    practiceActivities: "Four Activities",
    practiceActivitiesDesc: "Pacifying · Enriching · Magnetizing · Subduing",
    practiceMyJourney: "My Journey",
    practiceGroups: "Group Practices",

    // ── DharmaTeachingsHub ──────────────────────────────
    teachingsTitle: "Dharma Library",
    teachingsCredentialRequired: "Credential Required",
    teachingsCredentialDesc: "Some teachings require empowerment credentials",
    teachingsNoAccess: "You don't have access to this teaching yet",
    teachingsAll: "All Teachings",
    teachingsByTopic: "Browse by Topic",

    // ── Credential Application ──────────────────────────
    credApplyTitle: "Empowerment Credential Application",
    credApplyDesc: "Request credentials for empowerments you've received but are not yet recorded. Approved requests will unlock access to corresponding teachings.",
    credApplySelect: "Credential *",
    credApplySelectPlaceholder: "— Select —",
    credApplyDate: "Initiation Date",
    credApplyPlace: "Initiation Place",
    credApplyPlacePlaceholder: "e.g. Zongguo Monastery",
    credApplyTeacher: "Transmission Teacher",
    credApplyTeacherPlaceholder: "Teacher's name",
    credApplyNotes: "Additional Notes",
    credApplyNotesPlaceholder: "Additional information…",
    credApplySubmit: "Submit Application",
    credApplyNoKey: "Please select a credential",
    credApplyOk: "✓ Application submitted — awaiting review",
    credApplyFail: "Submission failed",
    credApplySubmitted: "✓ Application Submitted",
    credApplyAgain: "Apply Again",
    credApplyHistory: "Application History",
    credApplyStatusLabel: "Initiation Date:",
    credApplyReviewLabel: "Review Notes:",
    credApplyPending: "⏳ Pending Review",
    credApplyApproved: "✅ Approved",
    credApplyRejected: "❌ Rejected",

    // ── VajraSettings ───────────────────────────────────
    settingsTitle: "Settings",
    settingsLanguage: "Language",
    settingsNotifications: "Notifications",
    settingsPushEnabled: "Push Notifications",
    settingsPushDesc: "Receive daily energy insights and event reminders",
    settingsReportActivation: "Report Activation",
    settingsReportActivationDesc: "Link your LUMINA report to unlock teachings",
    settingsReportPlaceholder: "Enter your report number (e.g., L-2026-XXXX)",
    settingsActivate: "Activate",
    settingsActivating: "Activating…",
    settingsActivated: "✓ Report linked successfully",
    settingsMyCredentials: "My Credentials",
    settingsEnergyTools: "Energy Tools",
    settingsEnergyToolsDesc: "Show daily energy insights from LUMINA",

    // ── VajraDashboard ──────────────────────────────────
    dashWelcome: "Welcome",
    dashQuickLinks: "Quick Links",
    dashMyTeachers: "My Lineage Teachers",
    dashUpcomingEvents: "My Upcoming Events",
    dashNoEvents: "No upcoming events",
    dashEnergyInsight: "Daily Energy Insight",

    // ── OfferingHub / OfferingDetail ────────────────────
    offeringTargets: "Offering Targets",
    offeringAmount: "Amount",
    offeringCurrency: "Currency",
    offeringNote: "Note (optional)",
    offeringSubmit: "Submit Offering",
    offeringThankYou: "Thank you for your offering",
    offeringPaymentMethods: "Payment Methods",
    offeringPaypal: "PayPal",
    offeringEtransfer: "E-transfer",
    offeringWechat: "WeChat",
    offeringCompleted: "Completed",
    offeringMeritBoard: "Merit Board",
    offeringMeritDonors: "Merit Donors",
    offeringAnonymous: "Anonymous",

    // ── DharmaPath / MyJourney ──────────────────────────
    pathTitle: "Dharma Path",
    pathMyProgress: "My Progress",
    pathStages: "Stages",
    pathCompleted: "Completed",
    pathInProgress: "In Progress",
    pathNotStarted: "Not Started",
    pathNoProgress: "Begin your journey by exploring a lineage path",

    // ── ActivityPage ────────────────────────────────────
    activityTitle: "Four Activities",
    activityPacifying: "Pacifying",
    activityEnriching: "Enriching",
    activityMagnetizing: "Magnetizing",
    activitySubduing: "Subduing",

    // ── VajraShop ───────────────────────────────────────
    shopTitle: "Dharma Shop",
    shopFree: "Free",
    shopRequest: "Request Item",
    shopNoItems: "No items available at this time",
    shopBack: "Back to Shop",

    // ── Event Types ──────────────────────────────────────
    eventPuja: "Puja",
    eventRitual: "Ritual",
    eventEmpowerment: "Empowerment",
    eventTeaching: "Teaching",
    eventRetreat: "Retreat",
    eventWeeklyPractice: "Weekly Practice",
    eventOther: "Event",

    // ── Credentials ──────────────────────────────────────
    credEmpowerment: "Empowerment",
    credInProgress: "In Progress",
    credCompleted: "Completed",

    // ── Temple ──────────────────────────────────────────
    templeTitle: "Temples",
    templeDetails: "Temple Details",
    templeBack: "Back to Temples",

    // ── Gallery ─────────────────────────────────────────
    galleryTitle: "Historical Gallery",
    galleryNoPhotos: "No photos yet",

    // ── Common UI ───────────────────────────────────────
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    back: "Back",
    close: "Close",
    confirm: "Confirm",
    delete: "Delete",
    edit: "Edit",
    create: "Create",
    search: "Search",
    filter: "Filter",
    noResults: "No results found",
    error: "An error occurred",
    retry: "Retry",
    more: "More",
    viewAll: "View All",
    expand: "Expand",
    collapse: "Collapse",
    photo: "Photo",
    photos: "Photos",
    date: "Date",
    time: "Time",
    location: "Location",
    description: "Description",
    contact: "Contact",
    email: "Email",
    name: "Name",
    status: "Status",
    notes: "Notes",
    actions: "Actions",
    enabled: "Enabled",
    disabled: "Disabled",
    yes: "Yes",
    no: "No",

    // ── Admin (module labels only) ──────────────────────
    adminEvents: "Events Management",
    adminSangha: "Sangha Management",
    adminContent: "Content Management",
    adminFinance: "Finance",
  },

  zh: {
    // ── Header ──────────────────────────────────────────
    brandName: "如意宝金刚社群",
    brandSub: "BTF CANADA",
    staff: "员工",
    signOut: "退出",
    loading: "载入中…",
    loginRequired: "需登录",

    // ── Tabs ────────────────────────────────────────────
    tabHome: "首页",
    tabPractice: "修行",
    tabEvents: "法讯",
    tabTeachers: "传承上师",
    tabTeachersSub: "",
    tabService: "服务",
    tabTeachings: "法教",
    tabTeachingsSub: "",
    tabSettings: "设置",
    tabAdmin: "后台",

    // ── VajraLanding ────────────────────────────────────
    landingHero: "证悟之路",
    landingHeroSub: "BTF CANADA 如意宝金刚社群",
    landingRecentEvents: "近期法讯",
    landingPastEvents: "往期法会",
    landingViewDetails: "查看详情",
    landingOfferings: "随喜供养",
    landingOfferingsBtn: "BTF CANADA 日常供养 →",
    landingFiveMerits: "五大善业",
    landingFiveMeritsSub: "日有修持，月有共修，年有闭关——修行之路自然展开",
    landingTeachers: "传承上师",
    landingCommunity: "社群共修",
    landingFooter: "如意宝金刚社群 · BTF CANADA · 始于2024",
    landingNoEvents: "暂无近期法讯",
    landingPastEventsEmpty: "往期法会将显示在此处",
    landingLoginToView: "登录后查看完整内容",

    // ── ServiceHub ──────────────────────────────────────
    serviceOfferings: "随喜供养",
    serviceRequests: "祈请法事",
    serviceShop: "法宝流通",
    serviceContact: "联系我们",
    serviceOfferingsDesc: "供养三宝——以布施积聚资粮",
    serviceRequestsDesc: "祈请法会、修法及法务服务",
    serviceShopDesc: "免费结缘法宝",
    serviceContactDesc: "联系BTF社群",

    // ── DharmaHub ───────────────────────────────────────
    dharmaUpcoming: "近期法讯",
    dharmaPast: "往期法会",
    dharmaListView: "列表视图",
    dharmaCalendarView: "日历视图",
    dharmaRecurring: "定期共修",
    dharmaNoUpcoming: "暂无近期法讯，敬请关注",
    dharmaNoPast: "往期法会将在此处显示",

    // ── PracticeHub ─────────────────────────────────────
    practicePath: "修行次第",
    practicePathDesc: "五传承系统修行指南",
    practiceActivities: "事业法门",
    practiceActivitiesDesc: "息·增·怀·诛",
    practiceMyJourney: "我的修行",
    practiceGroups: "共修小组",

    // ── DharmaTeachingsHub ──────────────────────────────
    teachingsTitle: "教法图书馆",
    teachingsCredentialRequired: "需灌顶资质",
    teachingsCredentialDesc: "部分教法需要灌顶资质方可阅读",
    teachingsNoAccess: "您尚未获得此教法的访问权限",
    teachingsAll: "全部教法",
    teachingsByTopic: "按专题浏览",

    // ── Credential Application ──────────────────────────
    credApplyTitle: "灌顶资质申请",
    credApplyDesc: "曾领受但尚未录入系统的灌顶，可在此申请。通过后将自动解锁对应教法。",
    credApplySelect: "资质 *",
    credApplySelectPlaceholder: "— 选择 —",
    credApplyDate: "灌顶日期",
    credApplyPlace: "灌顶地点",
    credApplyPlacePlaceholder: "如：宗果寺",
    credApplyTeacher: "传法上师",
    credApplyTeacherPlaceholder: "上师名号",
    credApplyNotes: "补充说明",
    credApplyNotesPlaceholder: "如补充信息…",
    credApplySubmit: "提交申请",
    credApplyNoKey: "请选择资质",
    credApplyOk: "✓ 申请已提交，等待审核",
    credApplyFail: "提交失败",
    credApplySubmitted: "✓ 申请已提交",
    credApplyAgain: "再次申请",
    credApplyHistory: "申请记录",
    credApplyStatusLabel: "灌顶日期:",
    credApplyReviewLabel: "审核备注:",
    credApplyPending: "⏳ 审核中",
    credApplyApproved: "✅ 已通过",
    credApplyRejected: "❌ 未通过",

    // ── VajraSettings ───────────────────────────────────
    settingsTitle: "设置",
    settingsLanguage: "语言",
    settingsNotifications: "通知",
    settingsPushEnabled: "推送通知",
    settingsPushDesc: "接收每日能量洞察和法会提醒",
    settingsReportActivation: "报告激活",
    settingsReportActivationDesc: "关联澄光命盘报告以解锁教法",
    settingsReportPlaceholder: "输入报告编号（如 L-2026-XXXX）",
    settingsActivate: "激活",
    settingsActivating: "激活中…",
    settingsActivated: "✓ 报告关联成功",
    settingsMyCredentials: "我的资质",
    settingsEnergyTools: "能量工具",
    settingsEnergyToolsDesc: "显示来自澄光命盘的能量洞察",

    // ── VajraDashboard ──────────────────────────────────
    dashWelcome: "欢迎",
    dashQuickLinks: "快捷入口",
    dashMyTeachers: "我的传承上师",
    dashUpcomingEvents: "我的近期法会",
    dashNoEvents: "暂无近期法会",
    dashEnergyInsight: "每日能量洞察",

    // ── OfferingHub / OfferingDetail ────────────────────
    offeringTargets: "供养对象",
    offeringAmount: "金额",
    offeringCurrency: "币种",
    offeringNote: "备注（可选）",
    offeringSubmit: "提交供养",
    offeringThankYou: "感恩您的供养",
    offeringPaymentMethods: "支付方式",
    offeringPaypal: "PayPal",
    offeringEtransfer: "E-transfer",
    offeringWechat: "微信",
    offeringCompleted: "已圆满",
    offeringMeritBoard: "功德芳名",
    offeringMeritDonors: "功德主",
    offeringAnonymous: "匿名",

    // ── DharmaPath / MyJourney ──────────────────────────
    pathTitle: "修行次第",
    pathMyProgress: "我的进度",
    pathStages: "阶段",
    pathCompleted: "已完成",
    pathInProgress: "进行中",
    pathNotStarted: "未开始",
    pathNoProgress: "从探索传承次第开始您的修行之旅",

    // ── ActivityPage ────────────────────────────────────
    activityTitle: "事业法门",
    activityPacifying: "息",
    activityEnriching: "增",
    activityMagnetizing: "怀",
    activitySubduing: "诛",

    // ── VajraShop ───────────────────────────────────────
    shopTitle: "法宝流通",
    shopFree: "免费结缘",
    shopRequest: "申请结缘",
    shopNoItems: "暂无结缘物品",
    shopBack: "返回法宝",

    // ── Event Types ──────────────────────────────────────
    eventPuja: "法会",
    eventRitual: "法事",
    eventEmpowerment: "灌顶",
    eventTeaching: "教法",
    eventRetreat: "闭关",
    eventWeeklyPractice: "共修",
    eventOther: "活动",

    // ── Credentials ──────────────────────────────────────
    credEmpowerment: "灌顶",
    credInProgress: "修习中",
    credCompleted: "已圆满",

    // ── Temple ──────────────────────────────────────────
    templeTitle: "寺院",
    templeDetails: "寺院详情",
    templeBack: "返回寺院列表",

    // ── Gallery ─────────────────────────────────────────
    galleryTitle: "往期法会照片",
    galleryNoPhotos: "暂无照片",

    // ── Common UI ───────────────────────────────────────
    submit: "提交",
    cancel: "取消",
    save: "保存",
    back: "返回",
    close: "关闭",
    confirm: "确认",
    delete: "删除",
    edit: "编辑",
    create: "创建",
    search: "搜索",
    filter: "筛选",
    noResults: "暂无结果",
    error: "发生错误",
    retry: "重试",
    more: "更多",
    viewAll: "查看全部",
    expand: "展开",
    collapse: "收起",
    photo: "照片",
    photos: "照片",
    date: "日期",
    time: "时间",
    location: "地点",
    description: "描述",
    contact: "联系方式",
    email: "邮箱",
    name: "姓名",
    status: "状态",
    notes: "备注",
    actions: "操作",
    enabled: "已启用",
    disabled: "已禁用",
    yes: "是",
    no: "否",

    // ── Admin ───────────────────────────────────────────
    adminEvents: "法讯管理",
    adminSangha: "社群管理",
    adminContent: "内容管理",
    adminFinance: "财务管理",
  }
};

// Phase 39B: Offering target type style
export const TARGET_STYLE = {
  teacher:     { icon:"🪷", label:"上师",    color:GD,        bg:"rgba(139,105,20,0.08)" },
  monastery:   { icon:"🛕", label:"寺庙",    color:"#7c3aed", bg:"rgba(124,58,237,0.08)" },
  remote_puja: { icon:"🪔", label:"境外法会", color:DG,        bg:"rgba(6,78,59,0.08)" },
  platform:    { icon:"☸",  label:"平台支持", color:TXT2,      bg:"rgba(0,0,0,0.04)" },
};
